<template>
  <svg class="icon">
    <use :xlink:href="icons + '#' + iconId "></use>
  </svg>
</template>

<script>
  import icons from '@lex4you/styleguide/dist/assets/styleguide/icons/icons.svg';

  export default {
    props: ['iconId'],

    data() {
      return {
        icons: icons
      };
    }
  }
</script>
